import type { Dimensions } from 'modules/org_chart/models/Dimensions'
import type { PointNode } from 'modules/org_chart/models/PointNode'
import type { VisibleBounds } from 'modules/org_chart/models/VisibleBounds'

type PositionedNode = Pick<PointNode, 'x' | 'y'>

export const filterVisibleTreeNodes = <T extends PositionedNode>(
  nodes: T[],
  visibleBounds: VisibleBounds | undefined,
  [nodeWidth, nodeHeight]: Dimensions
): T[] => {
  if (!visibleBounds) {
    return nodes
  }

  const { minX, minY, maxX, maxY } = visibleBounds

  return nodes.filter(
    (node) =>
      node.x + nodeWidth >= minX && node.x <= maxX && node.y + nodeHeight >= minY && node.y <= maxY
  )
}
